<script setup lang="ts">
import { IconArrowNarrowLeft, IconArrowNarrowRight } from "@tabler/icons-vue";
import { TooltipRoot as Tooltip, TooltipTrigger } from "reka-ui";
import { useRouter } from "vue-router";
import Button from "@/components/ui/button/Button.vue";
import TooltipContent from "@/components/ui/tooltip/TooltipContent.vue";
import { useTopBarStore } from "@/stores/topBar";

const router = useRouter();

function handleBack() {
	if (useTopBarStore().canGoBack) {
		router.back();
	}
}

function handleForward() {
	if (useTopBarStore().canGoForward) {
		router.forward();
	}
}
</script>

<template>
	<div class="flex gap-1 items-center">
		<Tooltip>
			<TooltipTrigger as-child>
				<Button
					variant="ghost"
					size="icon-sm"
					@click="handleBack"
					:disabled="!useTopBarStore().canGoBack"
				>
					<IconArrowNarrowLeft size="24" class="" />
				</Button>
			</TooltipTrigger>
			<TooltipContent>
				<p class="text-sm">Back</p>
			</TooltipContent>
		</Tooltip>
		<Tooltip>
			<TooltipTrigger as-child>
				<Button
					variant="ghost"
					size="icon-sm"
					@click="handleForward"
					:disabled="!useTopBarStore().canGoForward"
				>
					<IconArrowNarrowRight size="24" class="" />
				</Button>
			</TooltipTrigger>
			<TooltipContent>
				<p class="text-sm">Forward</p>
			</TooltipContent>
		</Tooltip>
	</div>
</template>
